import React from "react";
import { motion } from "framer-motion";

const Homecontent = () => {
  return (
    <>
      <div id="home" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-style-all-caps"
            >
              Explore and
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
            <span className="color-text-gradient">Join</span> The Web3 Faith-Based Economy{" "}
              {/* <span className="color-text-gradient">Cloudax</span> : An
              Integrated Web3 Ecosystem Built To Scale{" "} */}
            </motion.div>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >Driving wholesome contents globally <br />with rewards in web3 tokens.
              {/* Cloudax is a flexible, easy-to-use, decentralized and scalable
              ecosystem built to power the next generation of innovative web3
              products. */}
            </motion.p>
            <div className="button-group">
              <a
                id=""
                href="https://launchpad.cloudax.io/"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">
                  Join Presale
                </span>
              </a>
              <a
                id=""
                href="https://docs.cloudax.io/"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">White Paper</span>
              </a>
            </div>
          </div>
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512d4-a2718ffa"
            className="image-wrapper"
          >
            <div
              data-poster-url="#"
              data-video-urls="videos/promo.mp4,videos/promo.webm"
              data-autoplay={true}
              data-loop={true}
              data-wf-ignore={true}
              className="image w-background-video w-background-video-atom"
            >
              <video
                id="5d771c2d-d18f-498c-96b6-c9750ff5d5c6-video"
                autoPlay={true}
                loop={true}
                style={{ backgroundImage: 'url("#")' }}
                muted={true}
                playsInline=""
                data-wf-ignore={true}
                data-object-fit="cover"
              >
                <source src="videos/promo.mp4" data-wf-ignore="true" />
                <source src="videos/promo.webm" data-wf-ignore="true" />
              </video>
              <div className="image-overlay" />
            </div>
            <div
              data-w-id="deafb146-5e18-f281-9d90-cae7f4e748f5"
              className="image-decoration"
            />
          </div>
        </div>
      </div>
      <a
        id="scroll"
        href="#scroll"
        className="icon-button scroll-arrow w-inline-block animate-bounce"
      >
        <img
          src="images/Arrow-Down-Gradient.svg"
          loading="lazy"
          alt="downward pointing arrow"
          className="ui-icon"
        />
      </a>

      <div id="reach" className="section wf-section">
        <div className="content-wrapper">
          {/* <div class="gap"></div> */}
          <div className="_4-column-grid width-100">
            <a
              href="#"
              className="metric-block card w-inline-block transform transition duration-500 hover:scale-110 hover:translate-y-2 hover:-rotate-3"
            >
              <div className="colorful-icon bg-color-primary">
                <img
                  src="images/checkmark_1.svg"
                  loading="lazy"
                  alt="Check Icon"
                  className="icon"
                />
              </div>
              <div className="metric-block-content">
                <h3 className="heading-xlarge no-margin">$0.004</h3>
                <div className="text-style-all-caps">Public Price</div>
              </div>
            </a>
            <a href="#" className="metric-block card w-inline-block transform transition duration-500 hover:scale-110 hover:translate-y-2 hover:-rotate-3">
              <div className="colorful-icon bg-color-primary">
                <img
                  src="images/checkmark_1.svg"
                  loading="lazy"
                  alt="Check Icon"
                  className="icon"
                />
              </div>
              <div className="metric-block-content">
                <h3 className="heading-xlarge no-margin">10B</h3>
                <div className="text-style-all-caps">Total Supply</div>
              </div>
            </a>
            <a href="#" className="metric-block card w-inline-block transform transition duration-500 hover:scale-110 hover:translate-y-2 hover:-rotate-3">
              <div className="colorful-icon bg-color-primary">
                <img
                  src="images/checkmark_1.svg"
                  loading="lazy"
                  alt="Check Icon"
                  className="icon"
                />
              </div>
              <div className="metric-block-content">
                <h3 className="heading-xlarge no-margin">559M</h3>
                <div className="text-style-all-caps">Initial Supply</div>
              </div>
            </a>
            <a
              href="https://cloudshopa.com/"
              target="_blank"
              className="metric-block card w-inline-block transform transition duration-500 hover:scale-110 hover:translate-y-2 hover:-rotate-3"
            >
              <img
                src="images/cloudax_logo_cap2.png"
                loading="lazy"
                alt="logocap Icon"
              />
              <div className="metric-block-content">
                <div className="text-style-all-caps">Explore Cloudshopa</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Homecontent;
